import { render, staticRenderFns } from "./print-collectionCode.vue?vue&type=template&id=589127f8&"
import script from "./print-collectionCode.vue?vue&type=script&lang=ts&"
export * from "./print-collectionCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports